import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-logo",
  "use": "icon-logo-usage",
  "viewBox": "0 0 80 80",
  "content": "<symbol viewBox=\"0 0 80 80\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-logo\">\n<path d=\"M64 37.2556L55.1709 28.5247L40.4186 43.113L25.629 28.5247L16.7999 37.2556L31.5523 51.844L16.7999 66.4323L25.629 75.2001L40.4186 60.5749L55.1709 75.2001L64 66.4323L49.2476 51.844L64 37.2556Z\" fill=\"black\" />\n<path d=\"M38.8166 4.80005H28.2367V21.5251H38.8166V4.80005Z\" fill=\"black\" />\n<path d=\"M52.5631 4.80005H41.9831V21.5251H52.5631V4.80005Z\" fill=\"black\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol